import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swiper from "swiper/bundle";


function initCardStackAnimationIndividual() {

  gsap.registerPlugin(ScrollTrigger);
  const cardItems = document.querySelectorAll('.card-stack-item');
  const wrapper = document.querySelector('.card-stacks');
  if (!cardItems.length || !wrapper) return;
  const triggerId = "cardStackScrollTrigger";
  // ✅ Kill previous ScrollTrigger if it exists
  const existingTrigger = ScrollTrigger.getById(triggerId);
  if (existingTrigger) {
    existingTrigger.kill();
    ScrollTrigger.refresh();
  }

  const wrap = document.querySelector('.card-stacks-wrap');
  if (wrap) {
    const prevSwiper = wrap.querySelector('.swiper');
    if (prevSwiper && prevSwiper.swiper) {
      prevSwiper.swiper.destroy(true, true);
      const originalItems = Array.from(document.querySelectorAll('.card-stack-item'));
      // Remove old swiper DOM structure
      while (wrap.firstChild) wrap.removeChild(wrap.firstChild);
      // Re-add original card-stack-item elements      
      originalItems.forEach(item => wrap.appendChild(item));
    }
  }
  

  const isMobile = window.innerWidth < 990;
  if (isMobile) {
    mobileCardStack();
    return; // Exit for mobile
  }  

  const totalCards = cardItems.length;
  const endChange = `+=${totalCards * 150}vh`;

  // Reset --progress on all cards
  cardItems.forEach((card) => {
    card.style.setProperty('--progress', '0');
  });

  // Create timeline with new ScrollTrigger
  const mainTimeline = gsap.timeline({
    scrollTrigger: {
      id: triggerId, // ✅ Assign unique ID
      //markers: true,
      trigger: wrapper,
      start: "100% 90%",
      end: endChange,
      pin: true,
      scrub: 1.5,
      anticipatePin: 1,
      pinSpacing: true,
      snap: {
        snapTo: (progress) => {
          const snapPoints = [];
          for (let i = 0; i <= totalCards - 1; i++) {
            snapPoints.push(i / (totalCards - 1));
          }
          return gsap.utils.snap(snapPoints, progress);
        },
        duration: { min: 0.3, max: 1.2 },
        ease: "power1.inOut",
        delay: 0.2,
        directional: false,
      },
      onUpdate: function (self) {
        const totalProgress = self.progress;

        cardItems.forEach((card, index) => {
          if (index === totalCards - 1) return;

          const cardStartProgress = index / (totalCards - 1);
          const cardEndProgress = (index + 1) / (totalCards - 1);
          let cardProgress = 0;

          if (totalProgress >= cardStartProgress && totalProgress <= cardEndProgress) {
            cardProgress = (totalProgress - cardStartProgress) / (cardEndProgress - cardStartProgress);
          } else if (totalProgress > cardEndProgress) {
            cardProgress = 1;
          }

          card.style.setProperty('--progress', cardProgress.toString());
        });
      },
    },
  });

  return mainTimeline;
}


function mobileCardStack() {
  const wrap = document.querySelector('.card-stacks-wrap');
  if (!wrap) return;

  // Remove previous Swiper instance if exists
  const prevSwiper = wrap.querySelector('.swiper');
  if (prevSwiper && prevSwiper.swiper) {
    prevSwiper.swiper.destroy(true, true);
    // Remove old swiper DOM structure
    while (wrap.firstChild) wrap.removeChild(wrap.firstChild);
    // Re-add original card-stack-item elements
    const originalItems = Array.from(document.querySelectorAll('.card-stack-item'));
    originalItems.forEach(item => wrap.appendChild(item));
  }

  // If not already structured for Swiper, create Swiper structure
  if (!wrap.classList.contains('swiper')) {
    // Create Swiper container and wrapper
    const swiperContainer = document.createElement('div');
    swiperContainer.className = 'swiper';
    const swiperWrapper = document.createElement('div');
    swiperWrapper.className = 'swiper-wrapper';
    // Move all card-stack-item into swiper-wrapper as swiper-slide
    Array.from(wrap.children).forEach(child => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(child.cloneNode(true));
      swiperWrapper.appendChild(slide);
    });
    swiperContainer.appendChild(swiperWrapper);
    // Add pagination and navigation if needed
    const pagination = document.createElement('div');
    pagination.className = 'swiper-pagination';
    swiperContainer.appendChild(pagination);
    // Clear wrap and append swiper
    wrap.innerHTML = '';
    wrap.appendChild(swiperContainer);
  }

  // Initialize Swiper
  const swiperEl = wrap.querySelector('.swiper');
  if (swiperEl) {
    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      loop: false,
      observer: true,
      observeParents: true,
    });
  }
}

export { initCardStackAnimationIndividual }


